import {
  Directive,
  HostBinding,
  Inject,
  Input,
  OnInit,
  OnDestroy,
} from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { AccordionDirective } from './accordion.directive';
import { MenuItemToggle } from './accordion.model';
import { AccordionService } from './accordion.service';

@Directive({
    selector: '[appAccordionLink]',
    standalone: false
})
export class AccordionLinkDirective implements OnInit, OnDestroy {

  @Input() public group: any;

  @HostBinding('class.selected')
  @Input()
  get selected(): boolean {
    return this._selected;
  }

  set selected(value: boolean) {
    this._selected = value;
    if (value) {
      this.nav.closeOtherLinks(this);
    }
  }

  protected _selected: boolean;
  protected nav: AccordionDirective;
  private accordionService: AccordionService;

  constructor(@Inject(AccordionDirective) nav: AccordionDirective,  @Inject(AccordionService) accordionService: AccordionService) {
    this.nav = nav;
    this.accordionService = accordionService;
  }

  ngOnInit(): any {
    this.nav.addLink(this);
  }

  ngOnDestroy(): any {
    this.nav.removeGroup(this);
  }

  toggle(): any {
    this.selected = !this.selected;

    const menuToggle = new MenuItemToggle();
    menuToggle.group = this.group;
    menuToggle.selected = this.selected;
    this.accordionService.menuItemToggleChange(menuToggle);
    requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
  }
}
